<template>
    <div>
        <div class="flex justify-content-center">
            <label>Epoch<b-form-select v-model="slots" :options="epochs" class="form-control" @input="updateFilter"></b-form-select></label>
            <label>Leader<b-form-select class="form-control" v-model="leader" :options="leaders" :multiple="false" :close-on-select="true" :placeholder="'Select Leader'" @input="updateFilter"></b-form-select></label>
            <label>Per Page<b-form-select v-model="perPage" class="form-control" :options="[5,50,100,250,500]"></b-form-select></label>
        </div>
        <vuetable ref="vuetable" api-url="/blocks/query"
                  :load-on-start="false"
                  :fields="[
                  {name:'slot', sortField: 'slot', title: 'Slot', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'block_time', sortField: 'block_time', title: 'Time', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'leader.leader', sortField: 'leader.leader', title: 'Leader', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'skipped', sortField: 'skipped', title: 'Skipped', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'txns', sortField: 'txns', title: '# Tx', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'votes', sortField: 'votes', title: '# Votes', titleClass: 'text-center', dataClass: 'text-center'},

                  {name:'nonvotes', sortField: 'nonvotes', title: '# Non-Votes', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'success', sortField: 'success', title: 'Successful', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'failed', sortField: 'failed', title: 'Failed', titleClass: 'text-center', dataClass: 'text-center'},
                  // {name: 'total', sortField: 'rewards', title: 'Total Fees', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'rewards', sortField: 'rewards', title: 'Validator Rewards', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'fees.jito_total', sortField: 'fees.jito_total', title: 'Jito Tips', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'fees.count', sortField: 'fees.count', title: '# Priority', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'fees.percentage', sortField: 'fees.percentage', title: '% Priority', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'fees.total', sortField: 'fees.total', title: 'Priority Fees', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'fees.average', sortField: 'fees.average', title: 'Average Priority', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'fees.max', sortField: 'fees.max', title: 'Max Priority Fee', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'cu'  , sortField: 'cu', title: 'CU', titleClass: 'text-center', dataClass: 'text-center'},
                  ]"
                  :per-page="perPage"
                  :append-params="filters"
                  :reactive-api-url="true"
                  @vuetable:pagination-data="onPaginationData"

                  data-path="data"
                  pagination-path=""

                  :css="tableCss"
        >
            <template #nonvotes="props">
                {{ props.rowData.txns - props.rowData.votes }}
            </template>
            <template #leader.leader="props">
                <a :href="'/validators/' + voteIds[props.rowData.leader.leader]"
                   class="text-blue-500">{{ formatKey(props.rowData.leader.leader) }}</a>
            </template>
            <template #total="props">
                {{ formatSol(props.rowData.rewards *2) }}
            </template>
            <template #rewards="props">
                {{ formatSol(props.rowData.rewards) }}
            </template>
            <template #fees.total="props">
                {{ formatSol(props.rowData.fees?.total) }}
            </template>

            <template #fees.average="props">
                {{ formatSol(props.rowData.fees?.average) }}
            </template>
            <template #fees.jito_total="props">
                {{ formatSol(props.rowData.fees?.jito_total) }}
            </template>
            <template #fees.max="props">
                {{ formatSol(props.rowData.fees?.max) }}
            </template>
            <template #cu="props">
                {{ formatCu(props.rowData.cu) }}m
            </template>
            <template #fees.percentage="props">
                {{ (props.rowData.fees?.percentage * 100).toFixed(2) }}%
            </template>
            <template #skipped="props">
                <span v-if="props.rowData.skipped" class="text-danger">Yes</span>
                <span v-else class="text-success">No</span>
            </template>
            <template #slot="props">

                <a target=_blank :href="'https://explorer.solana.com/block/' + props.rowData.slot" class="text-blue-500">{{ props.rowData.slot }}</a>
            </template>


        </vuetable>
        <vuetable-pagination ref="pagination"
                             @vuetable-pagination:change-page="onChangePage"
                             :css="paginationCss"
        ></vuetable-pagination>
    </div>
</template>

<script>

import Select2 from 'vue3-select2-component';
export default {
    name: "BlockExplorer",
    props: ['leaders', 'filterLeader', 'filterSlots','voteIds','epochs','filterEpoch'],
    components: {
        Select2
    },
    data() {
        return {
            perPage: 50,
            slots: [],
            leader: null,
            epoch: null,
            tableCss: {
                tableWrapper: '',
                tableHeaderClass: 'mb-0',
                tableBodyClass: 'mb-0',
                tableClass: 'table table-sm table-striped table-hover',
                loadingClass: 'loading',
                ascendingIcon: 'fa fa-chevron-up',
                descendingIcon: 'fa fa-chevron-down',
                ascendingClass: 'sorted-asc',
                descendingClass: 'sorted-desc',
                sortableIcon: 'fa fa-sort',
                detailRowClass: 'vuetable-detail-row',
                handleIcon: 'fa fa-bars text-secondary',
                renderIcon(classes, options) {
                    return `<i class="${classes.join(' ')}"></span>`
                }
            },
            paginationCss: {
                wrapperClass: 'pagination float-right',
                activeClass: 'active',
                disabledClass: 'disabled',
                pageClass: 'page-item',
                linkClass: 'page-link',
                paginationClass: 'pagination',
                paginationInfoClass: 'float-left',
                dropdownClass: 'form-control',
                icons: {
                    first: 'fa fa-chevron-left',
                    prev: 'fa fa-chevron-left',
                    next: 'fa fa-chevron-right',
                    last: 'fa fa-chevron-right',
                }

            },
            pageUrl: '',
            page: 1,
        }
    },
    mounted() {
        if (this.filterLeader) {
            this.leader = this.filterLeader;
        }
        if (this.filterSlots) {
            this.slots = this.filterSlots;
        }
        if (this.filterEpoch) {
            // this.slots = this.filterEpoch;
        }
        this.updateFilter()
    },
    methods: {
        formatNumber(value) {
            return value.toLocaleString();
        },
        formatSol(amount) {
            return (amount / 1000000000).toFixed(5);
        },
        formatCu(amount) {
            return (amount / 1000000).toFixed(2);
        },
        formatLeader(leader) {
            return this.leaders[leader]?.name || leader;
        },
        formatKey(address) {
            if (this.leaders[address]) {
                return this.leaders[address].substr(0, "Solana Compass".length) + '...';
            }

            return address.substr(0, 4) + '...' + address.substr(-4);
        },
        updateFilter() {
            this.$nextTick(() => {
                this.$refs.vuetable.reload();
            });
        },
        // when the pagination data is available, set it to pagination component
        onPaginationData(paginationData) {
            console.log('onPaginationData: ', paginationData)
            this.$refs.pagination.setPaginationData(paginationData)
            this.pageUrl = paginationData.first_page_url
            this.page = paginationData.current_page
        },
        // when the user click something that causes the page to change,
        // call "changePage" method in Vuetable, so that that page will be
        // requested from the API endpoint.
        onChangePage(page) {
            console.log('onChangePage: ', page)
            this.$refs.vuetable.changePage(page)
        }
    },
    computed: {
        filters() {
            let filters = {

            }
            if (this.leader) {
                filters["filter[leader.leader]"] = this.leader;
            }
            if (this.slots.length) {
                filters["filter[slots]"] = this.slots;
            }
            return filters
        }
    },
    watch: {
        pageUrl() {
            // get current query string from this.pageUrl
            var url = new URL(this.pageUrl);
            console.log('url', url)
            // get current query string from this.pageUrl
            var newQuery = url.searchParams;
            console.log('newQuery', newQuery)
            // set the page in the query string to the current page
            newQuery.set('page', this.page);
            // update browser history with the new query string
            let queryString = newQuery.toString()
            console.log('?'+ queryString)
            window.history.pushState(null, null, '?' + newQuery.toString());


        }
    }
}
</script>

<style >
.vuetable-body-wrapper {
    overflow-x: auto;

}
</style>
